import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DonationTable = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const utm_campaign = queryParams.get(
    'utm_campaign'
  ) || sessionStorage.getItem('utm_campaign');
  const title =
    queryParams?.get('title') && queryParams?.get('title') !== 'null'
      ? queryParams?.get('title')
      : JSON.parse(localStorage.getItem('after_redirect') ?? '{}')
          .projectTitle ?? '';
  const amount = queryParams?.get('amount')
    ? queryParams?.get('amount')
    : title === 'Ramdan2025'
    ? JSON.parse(localStorage.getItem('amount'))
    : '';
  const tips = queryParams?.get('tips') ?? '';
  const id = queryParams?.get('id') ?? '';
  const g = queryParams?.get('g') ?? '';
  const localGoodies = localStorage.getItem('goodies');
  const goodies = g
    ? g.split(',')
    : localGoodies && localGoodies.length
    ? localGoodies.split(',').filter((v) => v !== '' && v !== 'null')
    : [];

  const sumValue = amount
    ? Number(amount) +
      Number(tips || 0) +
      goodies.reduce((a, b) => Number(a) + Number(b), 0)
    : 0; // Always use 0 instead of empty string

  const totalValue = amount
    ? Number(amount) + goodies.reduce((a, b) => Number(a) + Number(b), 0)
    : 0;
  const PurchaseValue = amount
    ? Number(tips || 0) +
      0.05 *
        (Number(amount) + goodies.reduce((a, b) => Number(a) + Number(b), 0))
    : 0;

  useEffect(() => {
    if (window.fbq) {
      utm_campaign ? 
      window.fbq('track', 'Donate', {
        value: totalValue,
        currency: 'EUR',
        Goodie: localGoodies || 0,
        Projekt: title,
        Trinkgeld: tips,
        Unterstützung: amount,
        ProjektId: id || 0,
        utm_campaign: utm_campaign,
      }) :   window.fbq('track', 'Donate', {
        value: totalValue,
        currency: 'EUR',
        Goodie: localGoodies || 0,
        Projekt: title,
        Trinkgeld: tips,
        Unterstützung: amount,
        ProjektId: id || 0,
      })
      utm_campaign ?
      window.fbq('track', 'Purchase', {
        value: PurchaseValue,
        currency: 'EUR',
        Projekt: title,
        Goodie: localGoodies || 0,
        Summe: sumValue,
        ProjektId: id || 0,
        utm_campaign: utm_campaign,
      }) :  window.fbq('track', 'Purchase', {
        value: PurchaseValue,
        currency: 'EUR',
        Projekt: title,
        Goodie: localGoodies || 0,
        Summe: sumValue,
        ProjektId: id || 0,
      })  
    }
    JSON.stringify(localStorage.setItem('amount', null));
  }, []);

  return (
    <table className="donation-table">
      <caption>Deine Auswahl:</caption>
      <tr>
        <th>Projekt</th>
        <th>
          {title === 'Ramdan2025'
            ? 'Deine tägliche Ramadan-Spende 2025!'
            : title === 'dh25'
            ? 'Dhull Hijjah 2025'
            : title === 'freitag'
            ? 'Freitagsspende'
            : title}
        </th>
      </tr>
      {title !== 'Ramdan2025' && title !== 'dh25' && title !== 'freitag' && (
        <tr>
          <td>Projekt ID</td>
          <td>{id}</td>
        </tr>
      )}
      <tr>
        <td>Unterstützung</td>
        <td>{amount}</td>
      </tr>
      {!!goodies.length &&
        goodies.map((val) => (
          <tr>
            <td>Goodies</td>
            <td>{val}</td>
          </tr>
        ))}
      <tr>
        <td>
          {title === 'Ramdan2025' ? (
            <>Freiwilliger Betrag für commonsplace &#128154;</>
          ) : (
            'Trinkgeld'
          )}
        </td>
        <td>{tips}</td>
      </tr>
      <tr>
        <td>Summe</td>
        <td>
          {amount
            ? Number(amount) +
              Number(tips ?? '0') +
              goodies.reduce((a, b) => Number(a) + Number(b), 0)
            : ''}
        </td>
      </tr>
    </table>
  );
};

export default DonationTable;
